/// <reference path="./inventoryTurnsAnalysis.module.ts" />

/**
 * Checks generalSettings.enableInventoryTurnsAnalysis before the page mounts the
 * shared meevo-inventory-analysis web component. Fresh read on every open, same
 * call as the menu gate. Fails closed: a failed settings call hides the WC same
 * as the setting being off, rather than showing it on an unconfirmed default.
 */
angular.module('meevo.plugins.inventoryTurnsAnalysis').controller('InventoryTurnsAnalysisGateController', [
    '$scope',
    'meevo.components.common.DataService',
    function (
        $scope: angular.IScope,
        dataService: Meevo.Components.BaseClasses.IDataService,
    ) {
        var ctrl = this as any;
        ctrl.loading = true;
        ctrl.enabled = false;

        dataService.customMethodData('api/Tenant/BusinessInfo/Settings', 'GET', null)
            .then(function (res: any) {
                var generalSettings = res && res.data && res.data.generalSettings;
                ctrl.enabled = !!(generalSettings && generalSettings.enableInventoryTurnsAnalysis);
            })
            .catch(function () {
                ctrl.enabled = false;
            })
            .finally(function () {
                ctrl.loading = false;
            });
    }
]);
